<template>
	<div class="mb-4">
		<div
			class="col-12 p-0 d-flex flex-column nowrap align-items-center justify-content-center"
		>
			<img
				class="mb-2 img-fluid"
				:src="`/${feature}/images/oops.png`"
				alt="oops"
			/>
			<div class="container text-center my-4">
				<div class="title-3 text-primary-blue">
					{{ content.planner_notAvailable }}
				</div>
				<br />
				<div class="body text-grey-900">
					{{ notAvailableContactUsText }}
				</div>
			</div>
			<div
				class="container d-flex flex-column flex-md-row nowrap align-items-center justify-content-center"
			>
				<a href="/">
					<div
						class="oops-btn mb-2 cursor-pointer button-primary primary-normal d-flex align-items-center justify-content-center p-3 mx-3"
					>
						<span class="text-center">{{
							content.planner_notAvailableNewSearch
						}}</span>
					</div>
				</a>
				<a :href="stationRedirectLink">
					<div
						class="oops-btn mb-2 cursor-pointer button-primary primary-normal d-flex align-items-center justify-content-center p-3 mx-3"
					>
						<span class="text-center">{{ stationRedirectText }}</span>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "OopsBanner",
	computed: {
		...mapState(["content", "liheData", "feature"]),
		stationRedirectLink() {
			return `/se-results#station[]=${this.liheData["stationId"]}`;
		},
		stationRedirectText() {
			return (
				this.content.planner_notAvailableSeeFromTheSameSation +
				" " +
				this.liheData["station"]
			);
		},
		notAvailableContactUsText() {
			switch (window.location.hostname) {
				case "www.befr.yoonly.eu":
					return this.content.planner_notAvailableConatctUs_Yoonly_BE_FR;
				case "www.benl.yoonly.eu":
					return this.content.planner_notAvailableConatctUs_Yoonly_BE_NL;
				case "www.nl.yoonly.eu":
					return this.content.planner_notAvailableConatctUs_Yoonly_NL_NL;
				default:
					return this.content.planner_notAvailableConatctUs;
			}
		},
	},
};
</script>

<style scoped>
/* .oops-btn:hover {
	box-shadow: 0px 0px 4px 0px #0cb5dc;
} */
</style>
